import { render } from "./DocumentTableSortIndicator.vue?vue&type=template&id=b16af274&scoped=true"
import script from "./DocumentTableSortIndicator.vue?vue&type=script&lang=js"
export * from "./DocumentTableSortIndicator.vue?vue&type=script&lang=js"

import "./DocumentTableSortIndicator.vue?vue&type=style&index=0&id=b16af274&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b16af274"]])

export default __exports__